import gql from 'graphql-tag';

const ALL_CITIES_QUERY = gql`
  query AllCities {
    allCities {
      id
      minimumStaying
      relevance
      country {
        countryId
      }
    }
  }
`;

export const getAllCities = client => () =>
  client.query({ query: ALL_CITIES_QUERY });

export default {
  getAllCities
};
